module.exports = {
  // interface
  refresh: 'Refresh',
  the_side_slip: 'The Side Slip',
  close_current_tab: 'Close Current Tab',
  close_other_tab: 'Close Other Tab',
  close_all_tab: 'Close All Tab',

  add_next_level: 'Add Next Level',
  add_same_level: 'Add The Same Level',
  parent_category: 'Parent Category',

  new: 'New',
  copy_new: 'Copy New',
  choose_new: 'Choose New',
  edit: 'Edit',
  delete: 'Delete',
  batch_delete: 'Batch Delete',
  ok: 'OK',
  save: 'Save',
  save_and_copy: 'Save & Copy',
  cancel: 'Cancel',
  reset: 'Reset',
  refresh: 'Refresh',
  input_search_content: 'Input Search Content...',
  name: 'Name',
  full_name: 'Full Name',
  is_valid: 'Is Valid',
  yes: 'Yes',
  no: 'No',
  none: 'None',
  have: 'Have',
  nothing: 'Nothing',
  infomation: 'Infomation',
  remark: 'Remark',
  description: 'Description',
  serial_no: 'Serial No',
  close: 'Close',
  audit: 'Audit',
  unaudit: 'Unaudit',
  color: 'Color',
  is_cash: 'Is Cash',
  is_default: 'Is Default',
  print: 'Print',
  reprint: 'Reprint',
  import: 'Import',
  export: 'Export',
  menu: 'Menu',
  quotation: 'Quotation',
  message: 'Message',
  quote_item: 'Quote Item',
  preview: 'Preview',

  supplier: 'Supplier',
  client: 'Client',
  payment_method: 'Payment Method',
  warehouse: 'Warehouse',
  code: 'code',
  model: 'Model',
  standard: 'Standard',
  unit: 'Unit',
  category: 'Catetory',
  goods_category: 'Goods Category',
  positions: 'Positions',
  date: 'Date',
  please_choose: 'Please Choose',
  invoice_no: 'Invoice No',
  po_no: 'PO No.',
  po_no2: 'PO No.',
  view: 'View',
  goods: 'Goods',
  org_name: 'Organization Name',
  org: 'Organization',
  total: 'Total',
  retail_price: 'Retail Price',
  mini_retail_price: 'Mini Retail Price',
  consignment_price: 'Consignment Price',
  login: 'Login',
  logout: 'Logout',
  change_password: 'Change Password',
  the_front: 'The Front',
  the_back: 'The Back',

  contacts: 'Contacts',
  contacts_department: 'Contacts Department',
  contacts_post: 'Contacts Post',
  mobile: 'Mobile',
  office_phone: 'Office Phone',
  fax: 'Fax',
  email: 'E-mail',
  post_code: 'Post Code',
  address: 'Address',
  website: 'Website',

  workshop: 'Workshop',
  phone: 'Phone',
  principal: 'Principal',

  accountbook: 'Accountbook',
  ticket_number: 'Ticket Number',

  cost: 'Cost',
  brand: 'Brand',
  barcode: 'Barcode',
  barcode2: 'Barcode',
  qrcode: 'QRcode',
  imei: 'IMEI',

  search: 'Search',
  confirm: 'Confirm',
  discount: 'Discount',
  sell_price: 'Sell Price',
  seller: 'Seller',
  member: 'Member',
  member_name: 'Member Name',
  goods_search: 'Goods Search',
  hold_receipt: 'Hold Receipt',
  unchecked: 'Unchecked',
  order: 'Order',
  order_report: 'Order Report',
  return: 'Return',
  pay_money: 'Pay Money',
  paid_money: 'Paid Money',
  unpaid_money: 'Unpaid Money',

  in_warehouse: 'In Warehouse',
  out_warehouse: 'Out Warehouse',

  sundry_category: 'Sundry Category',
  money: 'Money',
  profit: 'Profit',

  user_group: 'User Group',
  is_see_money: 'See Money',
  is_see_cost: 'See Cost',

  is_front: 'Front',
  remember_login_name: 'Remember Name',
  remember_password: 'Remember Password',
  expiry_date: 'Expiry Date',
  cashier: 'Cashier',
  is_hold: 'Is Hold',
  is_order: 'Is Order',
  walk_in: 'Walk In',
  amount_received: 'Amount Received',
  discount_money: 'discount_money',
  payment: 'Payment',
  settle: 'Settle',
  obsolete: 'Obsolete',
  exchange: 'Exchange',
  return: 'Return',
  return_and_exchange: 'Return & Exchange',
  total_quantity: 'Total Quantity',
  change: 'Change',
  total_amount: 'Total Amount',
  pay_money: 'Pay Money',
  upload: 'Upload',
  fuzzy_query: 'Fuzzy Query',
  shelf_lift: 'Shelf Lift',
  maintenance_period: 'Maintenance Period',
  to_warehouse: 'To Warehouse',
  from_warehouse: 'From Warehouse',
  stock_transfer_in: 'Stock Transfer In',
  detail_data: 'Detail Data',
  shop: 'Shop',
  item: 'Item',
  source_quantity: 'Source Quantity',
  confirm_and_stay: 'Confirm & Stay',
  total_quantity: 'Total Quantity',
  confirm_password: 'Confirm password',

  delivery_person: 'Delivery person',
  status: 'Status',
  order_date: 'Order Date',
  order_date2: 'Order Date',
  delivery_date: 'Delivery Date',
  delivery_time: 'Delivery Time',
  order_flag: 'Order Token',
  client_family_name: 'Customer Last Name',
  client_phone: 'Client Phone',
  other: 'Other',
  extra_year: 'Extra One Year Guarantee',
  area: 'Area',
  update: 'Update',
  update_man: 'Update',
  start_time: 'Start Time',
  end_time: 'End Time',
  invoice_date: 'Invoice Date',
  drilling_wall: 'Drilling Wall',
  handler: 'Handling Man',
  uses: 'Uses',

  total_salary: 'Total Salary',
  base_salary: 'Base Salary',
  commission: 'Commission',
  special_bonus: 'Special Bonus',
  bonus: 'Bonus',
  maintain_commission: 'Maintenance Commission',
  maintain_expense: 'Maintenance Expenses',
  maintain_bonus: 'Maintenance Bonus',
  maintenance_bonus: 'Maintenance Bonus',
  maintenance_expense: 'Maintenance Expenses',
  maintenance_spare: 'Maintenance Spare',

  type: 'Type',
  type2: 'Category',
  sundry_expenditure: 'Miscellaneous Expenses',
  salary_expenditure: 'Salary Expenditure',
  fixed_expense: 'Fixed Expenses',
  shop_expense: 'Shop Spending',
  extra_expense: 'Extra Spend',
  netprofit: 'Net Profit',
  export_excel: 'Export Excel',

  current_password: 'Current Password',
  new_password: 'New Password',
  print_invoice: 'Print Invoice',
  job_title: 'Job',
  supplier_name: 'Supplier Name',
  modify_time: 'Modify time',
  for_delivery: 'Pending Delivery',
  processing: 'Processing',
  total_sales_volume: 'Total Sales',
  a_month_total_sales_volume: 'Total Monthly Sales',
  difference_quantity: 'Difference',
  replenish_application: 'Replenishment Application',
  application_quantity: 'Application Quantity',
  audit_quantity: 'Audit Quantity',
  replenish_quantity: 'Replenishment Quantity',
  estimated_date: 'Estimated Arrival Date',

  project: 'Project',
  project2: 'Project',
  project_category: 'Project Category',
  project_code: 'Project Number',
  project_name: 'Project Name',
  project_address: 'Project Address',
  deduct: 'Deduct',
  bank: 'Bank',
  account_no: 'Account Number',

  maintenance_status: 'Maintenance Status',
  notification_status: 'Notification Status',
  expected_finish_day: 'Estimated Completion Date',
  income_expenditure: 'Income / Expense',
  amount_mop: 'Amount/MOP',
  amount_hk: 'Amount/HKD',
  reimbursement_people: 'Reimburser',
  month_sell_quantity: 'Monthly Sales',
  sales_volume: 'Sales Volume',
  version: 'Version',
  //table分页文字
  table_jump_to: 'Jump To Page',
  table_page: ' ',
  table_go: 'Go',
  table_total: 'Total',
  table_item: 'Item',
  table_limit_each_page: 'Limit Each Page',

  password: 'Password',
  verify_password: 'Verify Password',
  login_name: 'Login Name',
  nickname: 'Nickname',

  summary: 'Summary',
  bank_name: 'Bank Name',
  balance: 'Balance',
  balance_mop: 'Balance/MOP',
  balance_hk: 'Balance/HKD',
  account_holder: 'Account Holder',

  //Table Title文字
  id: 'ID',
  amount: 'Amount',
  price: 'Unit Price',
  quantity: 'Quantity',
  goods_code: 'Product ID',
  goods_name: 'Product Name',
  is_audit: 'Audit',
  electroplate: 'Electroplating',
  is_electroplate: 'Electroplating',
  polishing: 'Polishing',
  is_polishing: 'Polishing',

  receivable: 'Amount Due',
  payable: 'Amount Due',
  deposit: 'Deposit',
  //提示

  leader: 'Leader',
  tel: 'Tel',
  location: 'Location',

  acceptance_date: 'Acceptance Date',
  client_name: 'Guest Name',
  acceptance_model: 'Acceptance Model',
  serial_number: 'Serial Number',
  serial_number2: 'Serial Number',
  graphic_lock: 'Graphic lock',
  maintain_history: 'Maintenance History',

  warranty_status: 'Warranty Status',

  follow_parts: 'Random Parts',

  fault_cause: 'Cause Of The Fault',

  fault_phenomenon: 'Fault phenomenon',
  need_parts: 'Required Parts',
  maintain_evaluate: 'Maintenance Evaluation',
  advance_payment: 'Advance Payment',
  spare_phone: 'Backup Phone',
  spare_model: 'Spare Model',
  retrieve_date: 'Retrieve Date',
  acceptance_status: 'Acceptance Status',

  choose_delivery_note: 'Choose A Delivery Note',
  export_pdf: 'Export PDF',
  export_list: 'Export List',
  export_monthly_analyze: 'Export Month Analysis',
  reinforcemoney: 'Security Deposit',
  reminder_date: 'Reminder Date',
  total_money: 'Total Amount',
  incomepay_type: 'Bill and Payment Type',
  difference_cost: 'Difference Cost',
  sell_date: 'Sale Date',
  setting_sales_volume: 'Setting Sales',
  negative_difference_quantity: 'Negative Difference',
  exchange_rate: 'Exchange Rate',

  product_category: 'Product Category',
  product: 'Product',
  problem_type: 'Problem Type',
  item_count: 'Item Count',
  function: 'Function',
  handling_type: 'Handling Type',
  handling_description: 'Handling Description',

  audited: 'Audited',
  unaudited: 'Unaudited',
  all: 'All',
  credit: 'Credit',
  repayment: 'Repayment',
  credit_amount: 'Credit Amount',
  repayment_amount: 'Repayment Amount',
  pay_type: 'Pay Type',
  paid: 'Paid',
  unpaid: 'Unpaid',
  make_journal: 'Make Journal',
  cash_journal: 'Cash Journal',
  bank_journal: 'Bank Journal',
  invoice_journal: 'Invoice Journal',
  receive_reminder: 'Receive Reminder',
  income: 'Income',
  expenditure: 'Expenditure',
  last_in_cost: 'Last In Cost',
  stock_cost: 'Stock Cost',
  cash_balance_mop: 'Cash Balance MOP',
  cash_balance_hk: 'Cash Balance HKD',
  bank_balance_mop: 'Bank Balance MOP',
  bank_balance_hk: 'Bank BalanceHKD',
  invoice_balance_mop: 'Invoice Balance MOP',
  invoice_balance_hk: 'Invoice Balance HKD',
  check_no: 'Check No',
  is_get: 'Get',
  is_get2: 'Gat',
  not_get: 'Not Get',
  payment_entry: 'Payment Entry',
  payment_type: 'Payment Type',
  show_index: 'Show Index',
  quote_remark: 'Quote Remark',
  greater_than_zero: 'Greater Than Zero',
  equal_to_zero: 'Equal To Zero',

  edit_mode: 'Edit Mode',
  close_other: 'Close Ohter',
  close_all: 'Close All',
  close_this: 'Close This',

  start_date: 'Start Date',
  end_date: 'End Date',
  select_week: 'Select A Week',

  // message
  confirm_save: 'Confirm Save',
  confirm_cancel: 'Confirm Cancel',
  confirm_delete: 'Confirm Delete',
  confirm_audit: 'Confirm audit',
  confirm_unaudit: 'Determine counter-review',
  confirm_obsolete: 'OK to void',
  confirm_transfer_in: 'Confirm transfer',
  confirm_print: 'Whether to print',

  please_choose_detail: 'Please Choose Detail',
  please_choose_payment_method: 'Please select a payment method',
  please_choose_client: 'Please select a client',
  please_enter_a_login_name: 'Please Enter Login Name',
  please_enter_password: 'Please Enter Password',

  save_success: 'Save Success',
  save_failed: 'Save Failed',
  save_data_success: 'Successfully Saved Data',
  save_data_failed: 'Failed To Save Data',
  delete_data_success: 'Delete Data Success',
  delete_data_failed: 'Delete Data Failed',
  audit_data_success: 'Audit Data Success',
  audit_data_failed: 'Audit Data Failed',
  unaudit_data_success: 'Unudit Data Success',
  unaudit_data_failed: 'Unaudit Data Failed',

  success: 'Success',
  failed: 'Failed',
  unknown_error: 'Unknown Error',

  will_delete_all: 'Will delete all subordinate data',
  data_does_not_exist: 'Data does not exist',
  no_data: 'No Data',
  prev_page: 'Previous',
  next_page: 'Next',
  low_stocks: 'Out of stock',
  insufficient_payment: 'Insufficient payment amount',
  login_name_or_password_wrong: 'Wrong login or password',
  no_permission: 'No permission',
  password_not_match: 'Password does not match',
  password_changed_successfully: 'Password changed successfully',
  can_not_have_special_characters: 'Cannot have special characters',
  can_not_empty: 'Cannot be empty',
  password_must_be_less_than_12_digits_and_no_spaces: 'Password must be less than 12 digits and no spaces can appear',
  do_not_underline_at_the_beginning_and_end: 'Underline cannot appear at the beginning and end',
  this_value_already_exists: 'The value already exists',
  must_be_unique: "Must Be Unique",
  if_hold: 'Whether Hold Single',
  data_not_found: 'No corresponding data was found',
  data_not_audited: 'Data not audited',
  lower_than_minimum_retail_price: 'Cannot fall below the minimum retail price',
  invoice: 'Invoice',
  proofreading_invoice: 'Logarithmic invoice',
  receipt: 'Receipt',
  order_invoice: 'Booking invoice',
  receipt_type: 'Document Type',

  change_client_well_del_all_continue: 'Reselecting the client will delete all the details and it will be unrecoverable, continue or not',
  current_password_not_match: 'Current password does not match',
  print_done: 'Print completed',
  unselected_data: 'Unselected data',
  process_success: 'Processed successfully',
  process_failed: 'Processing failed',
  process_error: 'Processing error',
  copy_done: 'Successfully copied',



  // menu
  menu_base_data: 'Base Data',
  menu_goods_category: 'Goods Category',
  menu_goods_standard: 'Product Specifications',
  menu_goods: 'Product Information',
  menu_unit: 'Unit',
  menu_color: 'Color',
  menu_payment_method: 'Billing Method',
  menu_payment_method2: 'Payment Method',
  menu_brand: 'Brand',
  menu_depart: 'Department',

  menu_member_manage: 'Member Management',
  menu_member_category: 'Member Category',
  menu_member: 'Member Profile',

  menu_purchase_manage: 'Purchase Management',
  menu_supplier_category: 'Supplier Category',
  menu_supplier: 'Supplier Profile',
  menu_purchase_in: 'Purchase Into Storage',
  menu_purchase_return: 'Purchase Returns',
  menu_purchase_auxiliary: 'Purchase Auxiliary Table',

  menu_outsource_manage: 'Outside Process Management',
  menu_outsource_out: 'Out Of Processing',
  menu_outsource_in: 'External Processing Income',
  menu_oem_in: 'Revenue for processing',
  menu_oem_out: 'Issue On Behalf Of Processing',

  menu_consignment_manage: 'Consignment Management',
  menu_consignment_out: 'Consignment Sent',
  menu_consignment_in: 'Consignment Return',
  menu_consignment_proceeds: 'Receipt Consignment',
  menu_consignment_uncollected: 'Unsold Money For Consignment',
  menu_consignment_proceeds_report: 'Consignment Receipt Report',

  menu_stock_transfer_out: 'Transfer Position Out',
  menu_stock_transfer_in: 'Transfer Into',

  menu_warehouse_manage: 'Warehouse Management',
  menu_warehouse: 'Warehouse Information',
  menu_stock_search: 'Stock Query',
  menu_stock_check: 'Inventory Check',
  menu_stock_adjust: 'Inventory Adjustment',
  menu_waste_in: 'Waste Product Into Storage',
  menu_waste_out: 'Out Of Stock',

  menu_production_manage: 'Production Management',
  menu_workshop: 'Workshop Settings',
  menu_bom_setting: 'BOM Settings',
  menu_production_plan: 'Production Plan',
  menu_production_picking: 'Production Picking',
  menu_production_return: 'Production Return',
  menu_product_in: 'Product Into The Warehouse',
  menu_transfer_auxiliary: 'Transfer Assistance Table',

  menu_sell_manage: 'Sales Management',
  menu_client_category: 'Customer Category',
  menu_client: 'Client Profile',
  menu_sell_order: 'Sales Order',
  menu_client_quote: 'Customer Quote',
  menu_sell_out: 'Sales Outbound',
  menu_sell_return: 'Sales Returns',

  menu_sundry_manage: 'Miscellaneous Management',
  menu_sundry_category: 'Miscellaneous Classification',
  menu_sundry_entry: 'Miscellaneous Entry',
  menu_shop_sundry: 'Miscellaneous Shops',
  menu_fixed_expense: 'Fixed Expenses',
  menu_shop_expense: 'Shop Spending',
  menu_extra_expense: 'Extra Spend',
  menu_salary_expenditure: 'Salary Expenses',
  menu_expenditure_report: 'Expense Report',

  menu_finance_manage: 'Financial Management',
  menu_accountbook: 'Account Book Settings',
  menu_receipt_entry: 'Receipt Entry',
  menu_payment_entry: 'Payment Entry',
  menu_receivable: 'Accounts Receivable',
  menu_payable: 'Accounts Payable',
  menu_receipt_voucher: 'Receipt Voucher',
  menu_payment_voucher: 'Payment Voucher',
  menu_receivable_offset: 'Offset Receivables',
  menu_payable_offset: 'Offsets Payable',
  menu_other_receipt: 'Other payments',
  menu_other_payment: 'Other payments',
  menu_expenses_type: 'Expense Type',
  menu_expenses_entry: 'Expense Entry',

  menu_delivery_manage: 'Delivery Management',
  menu_delivery_person: 'Delivery',
  menu_delivery_time: 'Delivery Period',
  menu_non_delivery_date: 'Non-delivery Date',
  menu_status: 'Status',
  menu_delivery_note: 'Delivery Note',
  menu_delivery_billing: 'Delivery Billing',
  menu_delivery_billing_report: 'Delivery Billing Report',

  menu_maintain_manage: 'Maintenance Management',
  menu_acceptance_status: 'Acceptance Status',
  menu_maintenance_status: 'Maintenance Status',
  menu_notification_status: 'Notification Status',
  menu_maintain_note: 'Maintenance order',
  menu_reservation_maintain_note: 'Reservation Order',
  menu_maintain_note_report: 'Maintenance Order Report',
  menu_reservation_maintain_note_report: 'Reservation Order Report',

  menu_system_setting: 'System Settings',
  menu_system_param: 'System Parameters',
  menu_user_group: 'User Group',
  menu_user: 'User',
  menu_change_password: 'Change Password',

  menu_report: 'Report',
  menu_goods_tracking: 'Goods Tracking',
  menu_purchase_in_report: 'Purchase Report',
  menu_purchase_in_count: 'Purchase Statistics',
  menu_stock_transfer_out_report: 'Report On Transfer Position',
  menu_stock_count: 'Inventory Statistics',
  menu_sell_order: 'Sales Order',
  menu_retail_profit: 'Retail Profit',
  menu_netprofit_report: 'Net Profit Table',
  menu_daily_settlement: 'Daily Billing',
  menu_daily_settlement_variance: 'Daily Settlement Difference',
  menu_retail_detail_report: 'Retail Details',
  menu_order_report: 'Booking Report',
  menu_obsolete_report: 'Obsolete Report',
  menu_return_report: 'Return Report',
  menu_loss_report: 'Loss Report',
  menu_profit_report: 'Profit Report',

  menu_replenish_manage: 'Replenishment Management',
  menu_replenish_application: 'Replenishment Request',

  menu_supplier_quote: 'Supplier\'s Quote',
  menu_purchase_order: 'Purchase Order',
  menu_purchase_receipt: 'Purchase Order',

  menu_object_manage: 'Project Management',
  menu_quote_recipt_status: 'Quote Status',
  menu_project_setting: 'Project Settings',
  menu_project_category: 'Project Category',
  menu_project_category2: 'Project Category',
  menu_project_quote: 'Project Quote',
  menu_project_quote2: 'Project Quote',
  menu_project_invoice: 'Project Invoice',
  menu_design_company_setting: 'Design Company Settings',
  menu_design_quote: 'Design Quote',

  menu_income_expenditure_manage: 'Receipt Management',
  menu_income_type: 'Receipt Type',
  menu_expenditure_type: 'Payment Type',

  menu_currency: 'Currency',
  menu_bank_setting: 'Bank Settings',
  menu_bank_journal_type: 'Journal Type',
  menu_cash_journal_entry: 'Cash Journal Entry',
  menu_bank_journal_entry: 'Bank Journal Entry',
  menu_invoice_journal_entry: 'Invoice Journal Entry',
  menu_check_journal_entry: 'Check Journal Entry',
  menu_debit_credit_entry: 'Loan Entry',
  menu_debit_entry: 'Loan Entry',
  menu_credit_entry: 'Loan Entry',
  menu_reimbursement_people: 'Reimbursement Person',
  menu_reimburse_entry: 'Reimbursement Entry',

  menu_project_quote_report: 'Project Quote Report',
  menu_design_quote_report: 'Design Quote Report',
  menu_receipt_report: 'Receipt Report',
  menu_payment_report: 'Payment Report',
  menu_receipt_payment_detail: 'Details Of Income And Expenditure',
  menu_project_receipt_payment_detail: 'Project Income And Expenditure Details',
  menu_profit_report: 'Profit Statement',
  menu_cash_journal_report: 'Cash Journal Report',
  menu_bank_journal_report: 'Bank Journal Report',
  menu_invoice_journal_report: 'Invoice Journal Report',
  menu_check_journal_report: 'Check Journal Report',
  menu_debit_credit_report: 'Credit Report',
  menu_reimburse_report: 'Reimbursement Report',

  menu_project_follow_up: 'Project Follow-up',
  menu_project_manage: 'Project Management',
  menu_after_sale_manage: 'After Sales Management',
  menu_after_sale: 'After-sales',
  menu_problem_collection: 'Problem Collection',
  menu_problem_handling: 'Problem Handling',
  menu_client_manage: 'Client Management',
  menu_receipt_type: 'Receipt Type',
  menu_product_category: 'Product Category',
  menu_product_info: 'Product Data',
  menu_area: 'Area',
  menu_problem_type: 'Problem Type',
  menu_handling_type: 'Handling Type',
  menu_unfinished_problem: 'Unfinished Auestion',
  menu_repayment_entry: 'Repayment Entry',
  menu_credit_repayment_entry: 'Loan Repayment Entry',
  menu_credit_report: 'Loan Report',
  menu_purchase_check_report: 'Purchase Log Report',
  menu_monthly_balance: 'Monthly',
  menu_daily_balance_report: 'Daily Report',
  menu_daily_balance_detail: 'Detail Report',
  menu_edition_fee: 'Edition fee',
  menu_edition_fee_return: 'Return Of Edition Fee',
  menu_staff_info: 'Staff Profile',
  menu_settlement: 'Billing',
  menu_supplier_statement: 'Supplier Statement',
  menu_client_statement: 'Client Statement',
  menu_attendance_manage: 'Attendance Management',
  menu_schedules_setting: 'Shift Definition',
  menu_holiday_entry: 'Holiday Registration',
  menu_absence_type: 'Absence Type',
  menu_absence_entry: 'Absent Registration',
  menu_special_record: 'Special Record',
  menu_attendance_entry: 'Attendance Entry',
  menu_attendance_statistics: 'Attendance Statistics',

  menu_salary_manage: 'Salary Management',
  menu_process_setting: 'Process Settings',
  menu_piecework_data_entry: 'Piece Data Entry',
  menu_piecework_report: 'Piece Report',
  menu_salary_statistics: 'Salary Statistics',

  menu_purchase_detail: 'Purchase Details',
  menu_sell_detail: 'Sales Details',
  menu_stock_alert: 'Stock Alert',
  menu_monthly_receivable_detail: 'Monthly Receivables',
  menu_monthly_payable_detail: 'Monthly Payable Transactions',
  menu_cash_account: 'Cash Account',
  menu_profit_statistics: 'Profit Statistics',
  menu_supplier_manage: 'Supplier Management',
  menu_payment_type: 'Payment Type',

  menu_service_category: 'Service Category',
  menu_service_manage: 'Service Manage',
  menu_trademark_category: 'Trademark Category',
  menu_order_manage: 'Order Manage',
  menu_client_manage: 'Client Manage',
  menu_about_us: 'About Us',
}